<template>
  <div class="scheme-add-ccontainer">
    <div class="scheme-add-title">{{ title }}</div>
    <div class="btn-box">
      <el-button type="primary" plain @click="beBack">返回</el-button>
      <el-button @click="refresh" type="primary" plain>刷新</el-button>
    </div>
    <div>
      <el-form ref="form" :rules="rules" :model="form" label-width="10%">
        <el-col :span="24" v-if="!userInfo.storeId">
          <el-form-item label='门店' prop="storeIds">
            <el-select v-model="form.storeIds" multiple collapse-tags :disabled="isEdit">
              <el-option v-for="(item,index) of storeList" :label="item.name" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='方案名称' prop="name">
            <el-input v-model="form.name" placeholder='请输入方案名称' :disabled="isEdit"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='计算方式' prop="commissionType">
            <el-select v-model="form.commissionType" @change="selectCommissionType" :disabled="isEdit">
              <el-option v-for="(item,index) of commissionTypeList" :label="item.label" :value="item.id" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label='备注' prop="remarks">
            <el-input
              style="width:700px;margin-bottom:20px"
              type="textarea"
              :rows="2"
              placeholder="请输入内容"
              :disabled="isEdit"
              v-model="form.remarks">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24" v-if="showGoods">
          <el-form-item label='参与商品'>
            <el-radio-group size="mini" v-model="form.participationType" :disabled="isEdit">
              <el-radio-button :label="item.id" :key="index" v-for="(item,index) in shopTypeList" @click.native="selectShopType($event.target.tagName,item,'hasShop')">{{item.name}}</el-radio-button>
            </el-radio-group>
            <span style="padding-left:20px;color:red;">注：提成比例区间0.00~~1.00</span>
          </el-form-item>
        </el-col>
        <!--全部商品显示-->
        <el-col :span="24"  v-if="form.participationType == '10' && showGoods">
          <el-form-item label='' label-width="5%">
            <div class="rete-style">
              <span style="margin-right: 20px">提成比例</span>
              <el-input v-model="form.commissionRatio" type="number" :min="0.00" :max="1" style="text-align: center" :disabled="isEdit"></el-input>
            </div>
          </el-form-item>
        </el-col>
        <!-- 为"指定分类"时显示 -->
        <el-col :span="24" v-if="form.participationType == '20'">
          <el-form-item label='' label-width="5%">
            <div class="classifyTree" v-if="!isEdit">
              <el-tree
                ref="treeForm"
                :check-strictly='true'
                :check-on-click-node='true'
                :data="takepartClassify"
                show-checkbox
                node-key="value"
                :default-checked-keys="treeMapList"
                :props="defaultTreeProps"
                @check='getCurrentNodes'>
              </el-tree>
            </div>
            <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperates2' :tableDataTitle='tableClassifyTitle' :tableDataP='form.csCommissionSchemeMapList'
                         @btnCallback='btnClass'>
              <el-table-column slot="commissionRatio" prop="commissionRatio" label="提成比例">
                <template slot-scope="scope">
                  <el-input-number v-model="scope.row.commissionRatio" :min='0.00' :max="1" placeholder='0.00' :disabled="isEdit"></el-input-number>
                </template>
              </el-table-column>
            </SimpleTable>
          </el-form-item>
        </el-col>
        <!-- 为"指定商品"时显示 -->
        <el-col :span="24" v-if="form.participationType == '30'">
          <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperates3' :tableDataTitle='tableGoodsTitle' :tableDataP='form.csCommissionSchemeMapList'
                       @btnCallback='btnGoods'>
            <el-table-column slot="commissionRatio" prop="commissionRatio" label="提成比例">
              <template slot-scope="scope">
                <el-input-number v-model="scope.row.commissionRatio" :min='0.00' :max="1" placeholder='0.00' :disabled="isEdit"></el-input-number>
              </template>
            </el-table-column>
          </SimpleTable>
        </el-col>
        <el-col :span="24" v-if="form.participationType != '30' && showGoods">
          <el-form-item label='不参与商品'>
            <el-radio-group size="mini" v-model="form.noParticipationType" :disabled="isEdit">
              <el-radio-button :label="item.id" :key="index" v-for="(item,index) in noShopTypeList" @click.native="selectShopType($event.target.tagName,item,'noShop')">{{item.name}}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <!--不参与商品 为"指定分类"时显示 -->
        <el-col :span="24" v-if="form.noParticipationType == '20'">
          <el-form-item label='' label-width="5%">
            <div class="classifyTree" v-if="!isEdit">
              <el-tree
                ref="treeForm"
                :check-strictly='true'
                :check-on-click-node='true'
                :data="takepartClassify"
                show-checkbox
                node-key="value"
                :default-checked-keys="treeMapList"
                :props="defaultTreeProps"
                @check='getCurrentNo'>
              </el-tree>
            </div>
            <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperatesClass' :tableDataTitle='tableClassifyTitle' :tableDataP='form.noCsCommissionSchemeMapList'
                         @btnCallback='noBtnClass'>
            </SimpleTable>
          </el-form-item>
        </el-col>
        <!--不参与商品 为"指定商品"时显示 -->
        <el-col :span="24" v-if="form.noParticipationType == '30' && form.participationType != '30'">
          <SimpleTable style="margin-top:10px;margin-bottom:30px" :tableStyleName='"dialogTable"' :tableOperates='tableOperatesGood' :tableDataTitle='tableGoodsTitle' :tableDataP='form.noCsCommissionSchemeMapList'
                       @btnCallback='noBtnGoods'>
          </SimpleTable>
        </el-col>
      </el-form>
      <el-col :span="24" v-if="!isEdit">
        <div class="foot">
          <el-button type='primary' @click="save()">保存</el-button>
          <el-button type='default' @click="reset()">重置</el-button>
        </div>
      </el-col>
    </div>
    <select-goods-dialog v-if="selectGoodsVisible" :lastTableData.sync='tableGoodsData' :searchParams="searchParams"
                         :selectGoods="selectGoods"
                         :selectGoodsVisible.sync='selectGoodsVisible'></select-goods-dialog>
  </div>
</template>
<script>
import api from '@/config/api'
import SimpleTable from '@/components/template/simpleTable'
import SelectGoodsDialog from '../../promotion/promotionTool/SelectGoodsDialog'
import SelectStoresDialog from "../../promotion/promotionTool/SelectStoresDialog";
export default {
  components:{
    SimpleTable,
    SelectStoresDialog,
    SelectGoodsDialog
  },
  data(){
    return {
      title:'新增提成方案',
      isEdit:false,
      showGoods:true,
      searchParams:{
        stCreateDttm:'',
        edCreateDttm:'',
        schemeUrl:'/api/eros/as/asGoodsSpecsMap/specs/page',
      },
      tableClassifyTitle:[
        {label:'分类名称',prop:'relateName'},
        {label:'提成比例',slot:'commissionRatio'},
      ],
      tableGoodsTitle:[
        {label:'序号',prop:'index'},
        {label: '条形码', prop: 'barCode'},
        {label: '商品名称', prop: 'relateName'},
        {label: '进货价', prop: 'buyPrice'},
        {label: '零售价(元)', prop: 'retailPrice'},
        {label: '提成比例', slot: 'commissionRatio'},
      ],
      tableOperates2: ['delete'],
      tableOperates3: ['delete'],
      tableOperatesClass: ['delete'],
      tableOperatesGood: ['delete'],
      selectGoods: [],
      tableGoodsData: [],
      selectGoodsVisible: false,
      noShopTypeList: [{name: '无', id: '10'}, {name: '指定分类', id: '20'}, {name: '指定商品', id: '30'},],
      shopTypeList: [{name: '全部商品', id: '10'}, {name: '指定分类', id: '20'}, {name: '指定商品', id: '30'},],
      commissionTypeList: [{name: '销售额*比例提成', id: '1'}, {name: '销售毛利*比例提成', id: '2'}, {name: '按商品档案提成值', id: '3'},],
      takepartClassify: [],//用户选择的分类
      treeMapList: [],//选中的树节点
      form: {
        storeIds: [],
        name: '',
        commissionType:'',
        participationType:'10',
        noParticipationType:'10',
        remarks:'',
        commissionRatio:0.00,
        csCommissionSchemeMapList:[],//指定类别或指定商品集合
        noCsCommissionSchemeMapList:[],// 不参与指定类别或指定商品集合
      },
      rules:{
        storeIds:[{required:true,message:'请选择门店',trigger: "change"}],
        name:[{required:true,message:'请填写方案名称',trigger: "blur"}],
        commissionType:[{required:true,message:'请选择计算方式',trigger: "change"}],
      },
      defaultTreeProps:{
        children: 'children',
        label: 'label'
      },
      userInfo:{},
      storeList:[],

    }
  },
  watch:{
    'form.participationType':{
      handler(val,old){
        switch (val) {
          case '10'://参与商品为“全部”
            this.noShopTypeList=[
              {name:'无',id:'10'},
              {name:'指定分类',id:'20'},
              {name:'指定商品',id:'30'}
            ]
            break;
          case '20'://参与商品为“指定分类”,不参与商品选项改变
            this.noShopTypeList=[
              {name:'无',id:'10'},
              {name:'指定商品',id:'30'}
            ]
            this.noShopTypeList=this.noShopTypeList||'10';//返回了用服务端，没返回默认无
            break;
          case '30'://参与商品为“指定商品”
          default:
            break;
        }
      },
      deep:true
    }
  },
  mounted() {
    this.getAllEnumeration()
    this.getDetail()
    this.commissionTypeList = this.$utils.getCacheStatus("csCommissionScheme.commissionType")
    this.userInfo = this.$utils.getSysUser()
    if(!this.userInfo.storeId) this.getStoreList()
  },
  methods:{
    getStoreList(){
      this.$axios.fetchPost(api.system.seStore+'/list',{}).then(res=>{
        if(res.code === 200){
          res.data.unshift({id:-1,name:'总部'})
          this.storeList = res.data
        }else{
          this.$message.error(res.errorMsg || '请求门店失败')
        }
      })
    },
    // 选择计算方式
    selectCommissionType(val){
      if(val == 30){
        this.showGoods = false
      }else{
        this.showGoods = true
      }
    },
    // 详情
    getDetail(){
      if(this.$route.query.type){
        if(this.$route.query.type == 'view'){
          this.isEdit = true
          this.title = '查看提成方案'
          this.tableOperates2 = null
          this.tableOperates3 = null
          this.tableOperatesClass=null
          this.tableOperatesGood=null
        }else{
          this.isEdit = false
          this.title = '复制提成方案'
          this.tableOperates2 = ['delete']
          this.tableOperates3 = ['delete']
          this.tableOperatesClass=['delete']
          this.tableOperatesGood=['delete']
        }
      }
      let params = {}
      if(this.$route.query.id){
        params = {
          id :this.$route.query.id
        }
        this.$axios.fetchGet(api.retail.csCommissionScheme+'?id='+this.$route.query.id).then((res)=>{
          if(res.code == 200){
            let arr = []
            if(res.data.storeId){
              arr.push(res.data.storeId)
            }else{
              arr.push(-1)
            }
            this.form = res.data
            this.form.storeIds = arr
            this.form.noCsCommissionSchemeMapList = res.data.noCsCommissionSchemeMapMVOList
            if(res.data.noCsCommissionSchemeMapMVOList && res.data.noCsCommissionSchemeMapMVOList.length > 0){
              res.data.noCsCommissionSchemeMapMVOList.forEach((v,i)=>{
                v.index = i + 1
              })
            }
            this.form.csCommissionSchemeMapList = res.data.csCommissionSchemeMapMVOList
            if(res.data.csCommissionSchemeMapMVOList && res.data.csCommissionSchemeMapMVOList.length > 0){
              res.data.csCommissionSchemeMapMVOList.forEach((v,i)=>{
                v.index = i + 1
              })
            }
            if(this.form.participationType == 20){
              this.noShopTypeList=[
                {name:'无',id:'10'},
                {name:'指定商品',id:'30'}
              ]
            }
            this.selectCommissionType(this.form.commissionType)
            if(this.$route.query.type == 'copy'){
              this.form.name = this.form.name + '(复制)'
              // 选中的树节点 回显
              this.treeMapList = []
              this.form.csCommissionSchemeMapList.forEach(v=>{
                this.treeMapList.push(v.retaleId)
              })
              this.form.noCsCommissionSchemeMapList.forEach(v=>{
                this.treeMapList.push(v.retaleId)
              })
            }
          }else{
            this.$message.error('获取详情失败')
            this.beBack()
          }
        })
      }
    },
    // 重置
    reset(){
      this.form={
        storeIds:[],
        name:'',
        commissionType:'',
        participationType:'10',
        noParticipationType:'10',
        remarks:'',
        commissionRatio:0.00,
        csCommissionSchemeMapList:[],//指定类别或指定商品集合
        noCsCommissionSchemeMapList:[],// 不参与指定类别或指定商品集合
      }
      this.treeMapList = []
    },
    // 提交
    save(){
      this.$refs.form.validate((valid) => {
        if (valid) {
          if(this.userInfo.storeId){
            this.form.storeIds.push(this.userInfo.storeId)
          }
          if(this.title = '新增提成方案'){
            this.insert()
          }else{// 复制
            this.copy()
          }
        }else{
          return false
        }
      })
    },
    // 新增
    insert(){
      this.form.status = 10;
      this.$loading({text:'提交中，请稍后。。。'})
      this.$axios.fetchPost(api.retail.csCommissionScheme,this.form).then((res)=>{
        if(res.code == 200){
          this.$notify({
            type: "success",
            title: '新增操作',
            message: '成功',
            showClose: false,
          });
          // this.$message.success('新增成功')
          this.beBack()
        }else{
          this.$message.error(res.errorMsg || '新增失败')
        }
      }).finally(()=>{
        this.$loading({}).close()
      })
    },
    // 复制
    copy(){
      this.form.id = '';
      this.$loading({text:'提交中，请稍后。。。'})
      this.$axios.fetchPost(api.retail.csCommissionScheme,this.form).then((res)=>{
        if(res.code == 200){
          this.$notify({
            type: "success",
            title: '复制操作',
            message: '成功',
            showClose: false,
          });
          // this.$message.success('复制成功')
          this.beBack()
        }else{
          this.$message.error(res.errorMsg || '复制失败')
        }
      }).finally(()=>{
        this.$loading({}).close()
      })
    },
    // 返回
    beBack(){
      this.$router.go(-1);
    },
    // 刷新
    refresh() {
      this.$router.go(0);
    },
    // 选择参与商品
    selectShopType(val,item,type){
      if(val!='INPUT') return ;
      if(type==='hasShop'){
        switch (item.id) {
          case '10'://参与为全部，不参与类型置为默认项无
            this.form.commissionRatio = 0.00
            this.form.noParticipationType='10'
            this.form.csCommissionSchemeMapList = []
            break;
          case '20'://参与为指定分类，不参与类型置为默认项无
            this.form.noParticipationType='10'
            this.treeMapList=[] // 树选中置空
            this.form.csCommissionSchemeMapList = []
            break;
          case '30'://只要点击指定商品就要弹出框。并且不参与类型置为默认项
            this.selectGoodsVisible=true;
            this.tableGoodsData = this.form.csCommissionSchemeMapList;
            this.selectGoods = this.tableGoodsData;
            break;
          default:
            break;
        }
      }
      if(type==='noShop'){//不参与商品
        switch (item.id) {
          case '10':
            this.form.noCsCommissionSchemeMapList = []
            break;
          case '20':
            this.treeMapList=[] // 树选中置空
            this.form.noCsCommissionSchemeMapList = []
            break;
          case '30'://只要点击指定商品就要弹出框
            this.selectGoodsVisible=true;
            this.tableGoodsData=this.form.noCsCommissionSchemeMapList;
            break;
          default:
            break;
        }
      }
    },
    // 不参与 点击树
    getCurrentNo(currentClickNode,{checkedNodes}){
      this.form.noCsCommissionSchemeMapList=[];
      this.treeMapList=[];
      for(let i=0;i<checkedNodes.length;i++){
        let objectAdaptor={
          retaleId:checkedNodes[i].value,
          relateName:checkedNodes[i].label,
        }
        this.form.noCsCommissionSchemeMapList.unshift(objectAdaptor);
        this.treeMapList.push(checkedNodes[i].value)
      }
    },
    //参与 点击树
    getCurrentNodes(currentClickNode,{checkedNodes}){
      console.log(checkedNodes)
      if(this.$route.query.type == 'copy'){
          //判断当前点击的节点是否为选中
          let isChecked=checkedNodes.find((item,index)=>{
            return currentClickNode==item;
          })
          if(isChecked){//选中
            this.form.csCommissionSchemeMapList.unshift({
              retaleId:currentClickNode.value,
              label:currentClickNode.label,
              relateName:currentClickNode.label,
              commissionRatio:Number('0')
            });
            this.treeMapList.push(currentClickNode.value)
          }else{//未选中
            let deleteIndex=this.form.csCommissionSchemeMapList.findIndex((item)=>{
              return item.value==currentClickNode.value;
            })
            this.form.csCommissionSchemeMapList.splice(deleteIndex,1);
          }
      }else{//新增
        this.form.csCommissionSchemeMapList=[];
        this.treeMapList=[];
        for(let i=0;i<checkedNodes.length;i++){
          let objectAdaptor={
            retaleId:checkedNodes[i].value,
            value:checkedNodes[i].value,
            label:checkedNodes[i].label,
            relateName:checkedNodes[i].label,
            commissionRatio:Number('0')
          }
          this.form.csCommissionSchemeMapList.unshift(objectAdaptor);
          this.treeMapList.push(checkedNodes[i].value)
        }
      }
      // if(this.formPurpose=='edit'){

      // }
    },
    // 参与 指定分类  删除
    btnClass(operatorType,row){
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.form.csCommissionSchemeMapList.length;i++){
            if(row==this.form.csCommissionSchemeMapList[i]){
              this.form.csCommissionSchemeMapList.splice(i,1);
              break;
            }
          }
          //反选勾掉树状结构选项
          let tempTreeChecked=[...this.treeMapList];
          for(let j=0;j<tempTreeChecked.length;j++){
            if(row.value==this.treeMapList[j]){
              this.treeMapList.splice(j,1);
            }
          }
          this.$refs.treeForm.setCheckedKeys(this.treeMapList);
          break;
        default:
          break;
      }
    },
    // 参与 指定商品 删除
    btnGoods(operatorType,row){
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.form.csCommissionSchemeMapList.length;i++){
            if(row==this.form.csCommissionSchemeMapList[i]){
              this.form.csCommissionSchemeMapList.splice(i,1);
              break;
            }
          }
          break;
        default:
          break;
      }
    },
    // 不参与 指定商品 删除
    noBtnGoods(operatorType,row){
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.form.noCsCommissionSchemeMapList.length;i++){
            if(row==this.form.noCsCommissionSchemeMapList[i]){
              this.form.noCsCommissionSchemeMapList.splice(i,1);
              break;
            }
          }
          break;
        default:
          break;
      }
    },
    // 不参与 指定分类  删除
    noBtnClass(operatorType,row){
      switch (operatorType) {
        case 'delete':
          for(let i=0;i<this.form.noCsCommissionSchemeMapList.length;i++){
            if(row==this.form.noCsCommissionSchemeMapList[i]){
              this.form.noCsCommissionSchemeMapList.splice(i,1);
              break;
            }
          }
          //反选勾掉树状结构选项
          let tempTreeChecked=[...this.treeMapList];
          for(let j=0;j<tempTreeChecked.length;j++){
            if(row.value==this.treeMapList[j]){
              this.treeMapList.splice(j,1);
            }
          }
          this.$refs.treeForm.setCheckedKeys(this.treeMapList);
          break;
        default:
          break;
      }
    },
    //初始化一些枚举数据
    getAllEnumeration(){
      const loading=this.$loading();
      //商品类别树状可选项
      this.$axios.fetchPost(api.archives.getCategoryTree+'/list').then((res)=>{
        loading.close();
        this.takepartClassify=[];
        if(res.code===200){
          this.takepartClassify=res.data;
        }else{
          this.$message.error('会员种类拉取错误!'+res.errorMsg);
        }
      })
    }
  },
}
</script>
<style scoped>
.scheme-add-ccontainer{
  background: #fff;
  border-radius: 8px;
  padding:10px 25px;
}
.scheme-add-ccontainer .scheme-add-title{
  font-size: 16px;
  color: #000;
  font-weight: 600;
  line-height: 30px;
  margin-bottom: 10px;
  display: flex;
}
.scheme-add-ccontainer .btn-box {
  text-align: left;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ccc;
}
.scheme-add-ccontainer .rete-style{
  width:700px;
  background-color: #f5f5f5;
  padding:15px 0;
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.scheme-add-ccontainer .classifyTree{
  max-height: 200px;
  overflow: auto;
}
.scheme-add-ccontainer .foot{
  margin-top: 50px;
  text-align: center;
}
>>> .el-tree-node.is-current{
  color:#333;
}
>>> .el-select__tags .el-tag.el-tag--info{
  padding-right:18px;
  max-width: unset;
}
</style>



// WEBPACK FOOTER //
// src/page/guide/commission/schemeAdd.vue